import React, { useEffect, useState } from "react";
import { collection, doc, getDoc, getDocs, query, where } from "firebase/firestore";
import { db } from "../../index";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../../spinner";
import Cookies from "js-cookie";

const LomdimLoginAher = () => {
    const params = useParams();
    const [sium, setSium] = useState(null);
    const [mappingData, setMappingData] = useState(null);
    const [lomedId, setLomedId] = useState('');
    const [loadingButton, setLoadingButton] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");
    const [isAdmin, setIsAdmin] = useState(false);
    const navigate = useNavigate();

    const ButtonWithSpinner = ({ isLoading, children, ...props }) => (
        <button {...props} disabled={isLoading || props.disabled}>
            {isLoading ? (
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            ) : children}
        </button>
    );

    function displayToastMsg(msg) {
        setErrorMessage(msg);
        const toastModal = document.getElementById('errorModal');
        const toastBootstrap = window.bootstrap.Toast.getOrCreateInstance(toastModal);
        toastBootstrap.show();
    }

    function handleLomedId() {
        if (lomedId.trim()) {
            setLoadingButton('lomedLogin');
            const lomedIdDigits = lomedId.replace(/\D/g, '');

            const queries = [];

            // Query by phone (digits only)
            if (lomedIdDigits) {
                queries.push(getDocs(query(collection(db, "usersAher"),
                    where("siumId", "==", params.siumId),
                    where("phone", "==", lomedIdDigits)
                )));
            }

            // Query by email
            if (lomedId.includes('@')) {
                queries.push(getDocs(query(collection(db, "usersAher"),
                    where("siumId", "==", params.siumId),
                    where("email", "==", String(lomedId).trim().toLowerCase())
                )));
            }

            Promise.all(queries).then(async (snapshots) => {
                for (const snapshot of snapshots) {
                    for (const userDoc of snapshot.docs) {
                        navigate('/userStatusAher/' + userDoc.id);
                        return;
                    }
                }

                setLoadingButton(null);
                displayToastMsg('לא נמצא לומד עם הפרטים שהוזנו');
            }).catch(e => {
                console.error("Error finding user: ", e);
                setLoadingButton(null);
                displayToastMsg('אירעה שגיאה בחיפוש הלומד');
            });
        }
    }

    useEffect(() => {
        const fetchSiumData = async () => {
            try {
                const docRef = doc(db, "siumimAher", params.siumId);
                const siumRef = await getDoc(docRef);

                if (siumRef.exists()) {
                    const siumData = siumRef.data();
                    setSium(siumData);

                    const cookieSiumId = Cookies.get('siumShasId');
                    setIsAdmin(cookieSiumId === siumRef.id);

                    // Fetch mapping data for book name
                    if (siumData.mipuiId) {
                        const mipuiRef = doc(db, "mipui", siumData.mipuiId);
                        const mipuiSnap = await getDoc(mipuiRef);
                        if (mipuiSnap.exists()) {
                            setMappingData(mipuiSnap.data());
                        }
                    }
                } else {
                    navigate("/");
                }
            } catch (error) {
                console.error("Error fetching sium:", error);
                navigate("/");
            }
        };

        fetchSiumData();
    }, [params.siumId, navigate]);

    if (sium && sium.kehilaName) {
        const bookName = mappingData?.bookName || "ספר";

        return (
            <div className="sium-main">
                <div className="sium-main-container">
                    <div className={isAdmin ? "basad-with-return" : ""}>
                        {isAdmin && (
                            <div className="return-container">
                                <a className="btn sium-button return-button"
                                   href={"/niulSiumAher/" + params.siumId + "/siumStatus"}>חזור</a>
                            </div>
                        )}
                        <div className="basad">
                            <span>בס"ד</span>
                            <br />
                            <span>להצלחת עם ישראל</span>
                        </div>
                    </div>
                    <div className="sium-logo">
                        <div className="sium-logo-img" onClick={() => navigate("/")} style={{ cursor: 'pointer' }}></div>
                    </div>
                    <div className="grid p-3 text-primary-emphasis bg-primary-subtle border border-primary-subtle rounded-3 sium-titles">
                        <h2>חלוקת {bookName} של {sium.kehilaName}</h2>
                        <h4>כניסה ללומדים</h4>
                        {sium.logo && <div className={sium.logo} />}
                    </div>
                    <div className="lomdim-login-content">
                        <div className="input-row">
                            <div className="input-container">
                                <input
                                    type="text"
                                    value={lomedId}
                                    className="input"
                                    onChange={(e) => setLomedId(e.target.value)}
                                    placeholder="אימייל או פלאפון"
                                    name="lomedId"
                                    onKeyDown={(e) => e.key === 'Enter' && handleLomedId()}
                                />
                            </div>
                            <div className="input-container">
                                <ButtonWithSpinner
                                    className="btn new-sium-button send-forgot-id dark-button"
                                    onClick={() => handleLomedId()}
                                    isLoading={loadingButton === 'lomedLogin'}
                                >
                                    כניסה ללומד
                                </ButtonWithSpinner>
                            </div>
                        </div>
                    </div>
                    <div className="toast-container position-fixed top-0 start-50 translate-middle-x">
                        <div id="errorModal" className="toast" role="alert" aria-live="assertive"
                             aria-atomic="true" data-bs-autohide="true" data-bs-delay="3000">
                            <button type="button" className="btn-close me-2 m-auto" data-bs-dismiss="toast"
                                    aria-label="Close"></button>
                            <div className="toast-body">
                                {errorMessage}
                            </div>
                        </div>
                    </div>
                    <div className="sium-bottom-page">
                        <span> © כל הזכויות שמורות לאתר סיום הש"ס</span>
                    </div>
                </div>
            </div>
        );
    } else {
        return <Spinner />;
    }
};

export default LomdimLoginAher;

